const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const OrderFraudControlQuery: any = {
    GetOrderFraudControl: Backofficebff + '/v1/orderfraudcontrol/listoforderfraud',
    SetFraudPaymentNotificationStatus: Backofficebff + '/v1/orderfraudcontrol/set-fraud-payment-notification-status',
};
